import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISTDBoxes_List_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISTDBoxes_List_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetUserWithGroupDetails: any[];
  GetUserWithGroupDetails_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  GetBoxesAllWithSearch: any[];
  GetBoxesAllWithSearch_dummy: any[];
  GetAllBoxesForExcel: any[];
  GetAllBoxesForExcel_dummy: any[];
  ExportExcel: any;
  ExportExcel_dummy: any;
  STDBoxesDeleteById: number;
  STDBoxesDeleteById_dummy: number;
  isComp580075Visible: "visible" | "hidden";
  isComp930590Visible: "visible" | "hidden";

  isMasterPageInitLoaded?: boolean;
  isMasterPageRecurringLoaded?: boolean;
  shouldTriggerPageInit?: boolean;
}

export class STDBoxes_List_ScreenBase extends React.PureComponent<
  ISTDBoxes_List_ScreenProps,
  any
> {
  stdboxes_list_136815_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "5adb5fbf-0a08-4609-96fe-3e733d906daf",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 854547, PropertyName: "value", Value: "KLT Kutu Listesi" },
        { Id: 416063, PropertyName: "placeholder", Value: "Ara..." },
        { Id: 333219, PropertyName: "label", Value: "Dışa Aktar" },
        { Id: 320719, PropertyName: "title", Value: "Kutu Numarası" },
        {
          Id: 935576,
          PropertyName: "value",
          Value: "[datafield:boxidentifier]",
        },
        { Id: 836413, PropertyName: "title", Value: "Müşteri Adı" },
        {
          Id: 778354,
          PropertyName: "value",
          Value: "[datafield:customername]",
        },
        { Id: 74712, PropertyName: "title", Value: "İstasyon Adı" },
        { Id: 163230, PropertyName: "value", Value: "[datafield:stationname]" },
        { Id: 874080, PropertyName: "title", Value: "Kutu Tipi" },
        { Id: 842504, PropertyName: "value", Value: "[datafield:boxtype]" },
        { Id: 237885, PropertyName: "title", Value: "Kutu İçi Miktar" },
        {
          Id: 746824,
          PropertyName: "value",
          Value: "[datafield:expectedquantity]",
        },
        { Id: 790552, PropertyName: "title", Value: "Ürün Adı" },
        { Id: 590037, PropertyName: "value", Value: "[datafield:productname]" },
        { Id: 99495, PropertyName: "title", Value: "Müşteri Ürün Kodu" },
        {
          Id: 213987,
          PropertyName: "value",
          Value: "[datafield:customerproductcode]",
        },
        { Id: 795808, PropertyName: "title", Value: "Müşteri Ürün Açıklaması" },
        {
          Id: 888368,
          PropertyName: "value",
          Value: "[datafield:customerproductdesc]",
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.stdboxes_list_416063_value_kuikaTextInputRef = React.createRef();
    this.stdboxes_list_136815_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetUserWithGroupDetails: [],
      IfThenElse: false,
      GetBoxesAllWithSearch: [],
      GetAllBoxesForExcel: [],
      ExportExcel: "",
      NAVIGATE: "",
      STDBoxesDeleteById: 0,
      isComp580075Visible: "hidden",
      isComp930590Visible: "hidden",

      isMasterPageInitLoaded: false,
      isMasterPageRecurringLoaded: false,
      shouldTriggerPageInit: false,
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "stdboxes_list",
        "layout2_screen"
      );
      return;
    }

    ReactSystemFunctions.validateToken();
    if (false) {
      await this.STDBoxes_ListPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "stdboxes_list",
      "layout2_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["manager"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "stdboxes_list",
      "layout2_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.STDBoxes_ListPageInit();
    }

    if (
      prevState.isMasterPageInitLoaded !== this.state.isMasterPageInitLoaded &&
      this.state.isMasterPageInitLoaded === true
    ) {
      await this.STDBoxes_ListPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  setMasterPageInitLoaded = (value: boolean) => {
    this.setState({ isMasterPageInitLoaded: value });
  };

  setMasterPageRecurringLoaded = (value: boolean) => {
    this.setState({ isMasterPageRecurringLoaded: value });
  };
  setShouldTriggerPageInit = (value: boolean) => {
    this.setState({ shouldTriggerPageInit: value });
  };

  STDBoxes_ListPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_List/STDBoxes_ListPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserWithGroupDetails = result?.data.getUserWithGroupDetails;
    formVars.stdboxes_list_910883_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserWithGroupDetails !== undefined
        ? stateVars.GetUserWithGroupDetails?.length > 0
          ? stateVars.GetUserWithGroupDetails[0].fullName
          : null
        : this.state.GetUserWithGroupDetails?.length > 0
        ? this.state.GetUserWithGroupDetails[0].fullName
        : null
    );
    formVars.stdboxes_list_463602_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserWithGroupDetails !== undefined
        ? stateVars.GetUserWithGroupDetails?.length > 0
          ? stateVars.GetUserWithGroupDetails[0].groupName
          : null
        : this.state.GetUserWithGroupDetails?.length > 0
        ? this.state.GetUserWithGroupDetails[0].groupName
        : null
    );
    stateVars.isComp580075Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxEdit
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxEdit
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp930590Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxDelete
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxDelete
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDBoxes_ListPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_ListPageInit_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "STDBoxes_List",
      "NavigateScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDBoxes_ListPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxView
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.STDBoxes_ListPageInit_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDBoxes_ListPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDBoxes_ListPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      searchFor_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_list_416063_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_List/STDBoxes_ListPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetBoxesAllWithSearch = result?.data.getBoxesAllWithSearch;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDBoxes_ListPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_ListPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.stdboxes_list_910883_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserWithGroupDetails !== undefined
        ? stateVars.GetUserWithGroupDetails?.length > 0
          ? stateVars.GetUserWithGroupDetails[0].fullName
          : null
        : this.state.GetUserWithGroupDetails?.length > 0
        ? this.state.GetUserWithGroupDetails[0].fullName
        : null
    );

    formVars.stdboxes_list_463602_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserWithGroupDetails !== undefined
        ? stateVars.GetUserWithGroupDetails?.length > 0
          ? stateVars.GetUserWithGroupDetails[0].groupName
          : null
        : this.state.GetUserWithGroupDetails?.length > 0
        ? this.state.GetUserWithGroupDetails[0].groupName
        : null
    );

    stateVars.dataSource_136815 =
      stateVars.GetBoxesAllWithSearch ?? this.state.GetBoxesAllWithSearch;

    stateVars.isComp580075Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxEdit
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxEdit
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp930590Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxDelete
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxDelete
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDBoxes_ListComponent_416063_onPressEnter = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      searchFor_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_list_416063_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_List/STDBoxes_ListComponent_416063_onPressEnter",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetBoxesAllWithSearch = result?.data.getBoxesAllWithSearch;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_ListComponent_416063_onPressEnter1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_ListComponent_416063_onPressEnter1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_136815 =
      stateVars.GetBoxesAllWithSearch ?? this.state.GetBoxesAllWithSearch;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDBoxes_ListComponent_416063_onBlur = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      searchFor_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_list_416063_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_List/STDBoxes_ListComponent_416063_onBlur",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetBoxesAllWithSearch = result?.data.getBoxesAllWithSearch;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDBoxes_ListComponent_416063_onBlur1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_ListComponent_416063_onBlur1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_136815 =
      stateVars.GetBoxesAllWithSearch ?? this.state.GetBoxesAllWithSearch;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDBoxes_ListComponent_333219_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      searchFor_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_list_416063_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      value_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, stateVars.GetAllBoxesForExcel),
        "any"
      ),
      header_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      footer_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      columns_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_List/STDBoxes_ListComponent_333219_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetAllBoxesForExcel = result?.data.getAllBoxesForExcel;
    stateVars.ExportExcel = result?.data.exportExcel;
    ReactSystemFunctions.downloadFile(result?.data?.exportExcel);
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  STDBoxes_ListComponent_935576_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxView
            : null
        ),
        true
      )
    ) {
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "STDBoxes_Details",
        "Id",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.value(this, "stdboxes_list_136815_value", "id"),
          "Guid"
        )
      );
      KuikaAppManager.addToPageInputVariables(
        "STDBoxes_Details",
        "stationId",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.value(
            this,
            "stdboxes_list_136815_value",
            "stationId"
          ),
          "Guid"
        )
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "STDBoxes_List",
        "STDBoxes_Details",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "315776",
        null,
        "right",
        "true",
        "602px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  STDBoxes_ListComponent_778354_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].customerView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].customerView
            : null
        ),
        true
      )
    ) {
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "STDCustomer_View",
        "Id",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.value(
            this,
            "stdboxes_list_136815_value",
            "customerId"
          ),
          "Guid"
        )
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "STDBoxes_List",
        "STDCustomer_View",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "135067",
        null,
        "right",
        "true",
        "500px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  STDBoxes_ListComponent_163230_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].stationsView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].stationsView
            : null
        ),
        true
      )
    ) {
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "Station_View",
        "Id",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.value(
            this,
            "stdboxes_list_136815_value",
            "stationId"
          ),
          "Guid"
        )
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "STDBoxes_List",
        "Station_View",
        "",
        "newTab",
        null,
        null,
        null,
        null,
        null,
        null,
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  STDBoxes_ListComponent_590037_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].productsView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].productsView
            : null
        ),
        true
      )
    ) {
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "STDProducts_View",
        "Id",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.value(
            this,
            "stdboxes_list_136815_value",
            "productId"
          ),
          "Guid"
        )
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "STDBoxes_List",
        "STDProducts_View",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "151090",
        null,
        "right",
        "true",
        "600px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  STDBoxes_ListComponent_213987_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].productsView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].productsView
            : null
        ),
        true
      )
    ) {
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "STDProducts_View",
        "Id",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.value(
            this,
            "stdboxes_list_136815_value",
            "productId"
          ),
          "Guid"
        )
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "STDBoxes_List",
        "STDProducts_View",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "357946",
        null,
        "right",
        "true",
        "600px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  STDBoxes_ListComponent_888368_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].productsView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].productsView
            : null
        ),
        true
      )
    ) {
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "STDProducts_View",
        "Id",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.value(
            this,
            "stdboxes_list_136815_value",
            "productId"
          ),
          "Guid"
        )
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "STDBoxes_List",
        "STDProducts_View",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "249820",
        null,
        "right",
        "true",
        "600px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  STDBoxes_ListComponent_580075_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "STDBoxes_Form",
      "Id",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "stdboxes_list_136815_value", "id"),
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "STDBoxes_Form",
      "stationId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "stdboxes_list_136815_value",
          "stationId"
        ),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "STDBoxes_List",
      "STDBoxes_Form",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "826993",
      null,
      "right",
      "true",
      "450px",
      "100",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDBoxes_ListComponent_930590_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "stdboxes_list_136815_value", "id"),
        "Guid"
      ),
      searchFor_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_list_416063_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "f2c0cbe0_de78_6f6c_5114_206e378b5ccb_confirmation",
        this.defaultML,
        "Kutu kaydını silmek istediğinize emin misiniz?"
      ),
      "poppins",
      "KLT Kutusu Sil",
      "trash",
      "#ff0000"
    );

    if (stateVars.Confirm) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "STDBoxes_List/STDBoxes_ListComponent_930590_onClick",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.STDBoxesDeleteById = result?.data.stdBoxesDeleteById;
      stateVars.GetBoxesAllWithSearch = result?.data.getBoxesAllWithSearch;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.STDBoxes_ListComponent_930590_onClick1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_ListComponent_930590_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_136815 =
      stateVars.GetBoxesAllWithSearch ?? this.state.GetBoxesAllWithSearch;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDBoxes_ListComponent_163230_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [
      ,
      315776,
      135067,
      151090,
      357946,
      249820,
      826993,
    ] as number[];
    if (
      isFromMaster ||
      ((window.kuika?.disableSmartExecutePageInit?.["STDBoxes_List"] ??
        false) &&
        pageInitCallerNavDiIDs.indexOf(diId) > -1)
    ) {
      await this.STDBoxes_ListPageInit();
    } else if (
      window.kuika?.serverRequestCount > 0 &&
      pageInitCallerNavDiIDs.indexOf(diId) > -1
    ) {
      await this.STDBoxes_ListPageInit();
    }
  }
}
